module.exports = __webpack_public_path__ + "img/main-gallery6.87853ef1.jpg";